import { render, staticRenderFns } from "./ApplicationsList.vue?vue&type=template&id=24715e26&scoped=true"
import script from "./ApplicationsList.vue?vue&type=script&lang=js"
export * from "./ApplicationsList.vue?vue&type=script&lang=js"
import style0 from "./ApplicationsList.vue?vue&type=style&index=0&id=24715e26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24715e26",
  null
  
)

export default component.exports